module.exports = __webpack_public_path__ + "img/91.b7a23b8.png";